/**
 * Generic promo-campaign switch.
 *
 * Whether a promo campaign is currently running. Default OFF.
 * To run a campaign: set VITE_CAMPAIGN_ACTIVE=true (and redeploy).
 * Optional VITE_CAMPAIGN_END (ISO datetime) auto-deactivates at that time as a
 * safety net if the scheduled deactivation redeploy misfires.
 *
 * Gates the campaign features: "Code einlösen", "Tippspiel", "Team öffnen".
 */
export function isCampaignActive(): boolean {
  if (import.meta.env.VITE_CAMPAIGN_ACTIVE !== "true") return false;
  const end = import.meta.env.VITE_CAMPAIGN_END;
  if (end && Date.now() > new Date(end).getTime()) return false;
  return true;
}
